// extracted by mini-css-extract-plugin
export default {"spin":"spin_spin__UIZ1K","SpinAnimation":"spin_SpinAnimation__HY+Oi"};